import { __exports as EAN5 } from "./index203.js";
import { __require as requireConstants } from "./index200.js";
import { __require as requireEncoder } from "./index204.js";
import { __require as requireBarcode } from "./index158.js";
var hasRequiredEAN5;
function requireEAN5() {
  if (hasRequiredEAN5) return EAN5;
  hasRequiredEAN5 = 1;
  Object.defineProperty(EAN5, "__esModule", {
    value: true
  });
  var _createClass = /* @__PURE__ */ (function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  })();
  var _constants = requireConstants();
  var _encoder = requireEncoder();
  var _encoder2 = _interopRequireDefault(_encoder);
  var _Barcode2 = requireBarcode();
  var _Barcode3 = _interopRequireDefault(_Barcode2);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var checksum = function checksum2(data) {
    var result = data.split("").map(function(n) {
      return +n;
    }).reduce(function(sum, a, idx) {
      return idx % 2 ? sum + a * 9 : sum + a * 3;
    }, 0);
    return result % 10;
  };
  var EAN5$1 = (function(_Barcode) {
    _inherits(EAN52, _Barcode);
    function EAN52(data, options) {
      _classCallCheck(this, EAN52);
      return _possibleConstructorReturn(this, (EAN52.__proto__ || Object.getPrototypeOf(EAN52)).call(this, data, options));
    }
    _createClass(EAN52, [{
      key: "valid",
      value: function valid() {
        return this.data.search(/^[0-9]{5}$/) !== -1;
      }
    }, {
      key: "encode",
      value: function encode() {
        var structure = _constants.EAN5_STRUCTURE[checksum(this.data)];
        return {
          data: "1011" + (0, _encoder2.default)(this.data, structure, "01"),
          text: this.text
        };
      }
    }]);
    return EAN52;
  })(_Barcode3.default);
  EAN5.default = EAN5$1;
  return EAN5;
}
export {
  requireEAN5 as __require
};
//# sourceMappingURL=index167.js.map
